export const MEMBER_SPEND_PER_POINT_RUPIAH = 10_000;
export const MEMBER_POINT_VALUE_RUPIAH = 50;

function nonNegativeInteger(value: number): number {
  return Number.isSafeInteger(value) && value > 0 ? value : 0;
}

export function memberPointsFromPurchase(purchaseAmount: number): number {
  return Math.floor(
    nonNegativeInteger(purchaseAmount) / MEMBER_SPEND_PER_POINT_RUPIAH,
  );
}

export function memberPointDiscount(
  points: number,
  pointValueRupiah = MEMBER_POINT_VALUE_RUPIAH,
): number {
  return nonNegativeInteger(points) * nonNegativeInteger(pointValueRupiah);
}

export function maximumRedeemableMemberPoints(
  pointsBalance: number,
  subtotal: number,
  pointValueRupiah = MEMBER_POINT_VALUE_RUPIAH,
): number {
  const value = nonNegativeInteger(pointValueRupiah);
  if (value === 0) return 0;
  return Math.min(
    nonNegativeInteger(pointsBalance),
    Math.floor(nonNegativeInteger(subtotal) / value),
  );
}
